export const getColumnLetter = (index) => {
  let letter = '';
  while (index >= 0) {
    letter = String.fromCharCode(65 + (index % 26)) + letter;
    index = Math.floor(index / 26) - 1;
  }
  return letter;
};

export const getColumnIndex = (columns, columnId) => {
  return columns.findIndex(col => col.id === columnId);
};

export const createEmptyRow = (columns) => {
  const row = {};
  columns.forEach(c => (row[c.id] = ""));
  return row;
};

export const isCellInRange = (rowIndex, colIndex, range) => {
  if (!range) return false;
  return (
    rowIndex >= range.startRow &&
    rowIndex <= range.endRow &&
    colIndex >= range.startCol &&
    colIndex <= range.endCol
  );
};

// Column resize helpers
export const calculateColumnWidth = (width) => {
  return Math.max(width, 50); // Minimum width 50px
};

export const getTableElement = () => {
  return document.querySelector('.excel-table');
};

export const updateColumnWidth = (columns, columnIndex, newWidth) => {
  const updatedColumns = [...columns];
  updatedColumns[columnIndex] = {
    ...updatedColumns[columnIndex],
    width: calculateColumnWidth(newWidth)
  };
  return updatedColumns;
};